export const RESET_STATE = Symbol('migrationToWorkbook/RESET_STATE');

export const GET_ENTRY_LOADING = Symbol('migrationToWorkbook/GET_ENTRY_LOADING');
export const GET_ENTRY_SUCCESS = Symbol('migrationToWorkbook/GET_ENTRY_SUCCESS');
export const GET_ENTRY_FAILED = Symbol('migrationToWorkbook/GET_ENTRY_FAILED');

export const GET_RELATIONS_GRAPH_LOADING = Symbol(
    'migrationToWorkbook/GET_RELATIONS_GRAPH_LOADING',
);
export const GET_RELATIONS_GRAPH_SUCCESS = Symbol(
    'migrationToWorkbook/GET_RELATIONS_GRAPH_SUCCESS',
);
export const GET_RELATIONS_GRAPH_FAILED = Symbol('migrationToWorkbook/GET_RELATIONS_GRAPH_FAILED');

export const GET_RELATIONS_LOADING = Symbol('migrationToWorkbook/GET_RELATIONS_LOADING');
export const GET_RELATIONS_SUCCESS = Symbol('migrationToWorkbook/GET_RELATIONS_SUCCESS');
export const GET_RELATIONS_FAILED = Symbol('migrationToWorkbook/GET_RELATIONS_FAILED');

export const MIGRATE_ENTRIES_TO_WORKBOOK_LOADING = Symbol(
    'migrationToWorkbook/MIGRATE_ENTRIES_TO_WORKBOOK_LOADING',
);
export const MIGRATE_ENTRIES_TO_WORKBOOK_SUCCESS = Symbol(
    'migrationToWorkbook/MIGRATE_ENTRIES_TO_WORKBOOK_SUCCESS',
);
export const MIGRATE_ENTRIES_TO_WORKBOOK_FAILED = Symbol(
    'migrationToWorkbook/MIGRATE_ENTRIES_TO_WORKBOOK_FAILED',
);
